import appAPI from '@/api/modules/app.api.js';
import resourceAPI from '@/api/modules/resource.api.js';

import { ErrorService } from '@/services/error-service.js';
import i18n from '@/common/i18n/i18n.js';

import modules from './resources';

/**************** STATE *******************/
const state = {

  resourceDataFormats: [],
  resourceKinds: [],
  resourcesError: null,


  schedulers: []
};

/**************** GETTERS *****************/
const getters = {


};

/*************** MUTATIONS ****************/
const mutations = {

  SET_RESOURCE_DATA_FORMATS: (state, payload) => {
    if (payload) {
      state.resourceDataFormats = payload;
    }
  },

  SET_RESOURCE_KINDS: (state, payload) => {
    if (payload) {
      state.resourceKinds = payload;
    }
  },


  SET_ERROR: (state, error) => {
    if (error) {
      ErrorService.onError(error);
    }
    state.resourcesError = error;
  },

  SET_SCHEDULERS: (state, payload) => {
    if (payload.results) {
      state.schedulers = [...payload.results];
    }
  }
};
/**************** ACTIONS *****************/
const actions = {



  PATCH_RESOURCE: async (context, { id, data }) => {
    await resourceAPI.patchResource(id, data);
  },

  GET_RESOURCE_DATA_FORMATS: async ({ commit }) => {
    const formats = await resourceAPI.getResourceDataFormats();
    commit('SET_RESOURCE_DATA_FORMATS', formats);
  },

  GET_RESOURCE_KINDS: async ({ commit }) => {
    const kinds = await resourceAPI.getResourceKinds();
    commit('SET_RESOURCE_KINDS', kinds);
  },



  DELETE_RESOURCE_FROM_DATASET: async ({ commit }, { resourceToDatasetId, resource }) => {
    try {
      await resourceAPI.deleteResourceToDataset(resourceToDatasetId);
      commit('SET_ERROR', null);
      ErrorService.onSuccess(
        true,
        i18n.messages[i18n.locale].messages.success.resource.removed
          .replace('{name}', resource && resource.display_name ? resource.display_name : ''),
      );
    } catch (error) {
      commit('SET_ERROR', error);
    }
  },

  DELETE_RESOURCE: async ({ commit }, resource) => {
    try {
      await resourceAPI.deleteResource(resource.id);
      commit('SET_ERROR', null);
      ErrorService.onSuccess(
        true,
        i18n.messages[i18n.locale].messages.success.resource.deleted
          .replace('{name}', resource && resource.display_name ? resource.display_name : ''),
      );
    } catch (error) {
      commit('SET_ERROR', error);
    }
  },

  GET_SCHEDULERS: async ({ commit }) => {
    const schedulers = await appAPI.getSchedulers();
    commit('SET_SCHEDULERS', schedulers);
  }
};

export default {
  namespaced: true,
  modules,
  state,
  getters,
  actions,
  mutations,
};
